module.exports = __webpack_public_path__ + "app/principal/modals/modal-legal-entity-perimeter-3_vXlpBd.html";